"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setOrderType = exports.resetSelectCar = exports.setSelectCar = exports.setFilterGeneration = exports.setFilterBrand = exports.setFilterModel = exports.setStageFilter = exports.resetPromotionData = exports.setPromotionData = exports.closeModal = exports.openModal = exports.selectCarsLoader = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var selectCarInitialState_1 = require("../selectCarInitialState");
var ScrollManager_1 = require("../../helpers/ScrollManager");
var selectCarsLoader = (0, toolkit_1.createAsyncThunk)('modal/modalSelectCarsFetch', function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/cars?").concat(url), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.json()];
        }
    });
}); });
exports.selectCarsLoader = selectCarsLoader;
var modalSlice = (0, toolkit_1.createSlice)({
    name: 'modal',
    initialState: selectCarInitialState_1.initialStateModal,
    reducers: {
        openModal: function (state, action) {
            state.modals[action.payload].modalState = true;
            ScrollManager_1.scrollManager.scrollOff();
        },
        closeModal: function (state, action) {
            state.modals[action.payload].modalState = false;
            ScrollManager_1.scrollManager.scrollOn();
        },
        setOrderType: function (state, action) {
            state.modals.catalogOrder.orderType = action.payload;
        },
        setPromotionData: function (state, action) {
            state.modals.promotion.title = action.payload.title;
            state.modals.promotion.description = action.payload.description;
            state.modals.promotion.link = action.payload.link;
        },
        resetPromotionData: function (state) {
            state.modals.promotion.title = '';
            state.modals.promotion.description = '';
            state.modals.promotion.link = '';
        },
        setFilterBrand: function (state, action) {
            var _a = action.payload, nextValue = _a.nextValue, thisValue = _a.thisValue, selected = _a.selected, status = _a.status;
            var selectModal = state.modals.selectCar.filter;
            selectModal.brand.nextValue = nextValue;
            selectModal.brand.thisValue = thisValue;
            selectModal.brand.status = status;
            selectModal.brand.selected = selected;
            selectModal.model.thisValue = nextValue;
            selectModal.stage = 2;
            selectModal.model.status = true;
            selectModal.generation.status = false;
        },
        setFilterModel: function (state, action) {
            var _a = action.payload, nextValue = _a.nextValue, thisValue = _a.thisValue, selected = _a.selected, status = _a.status;
            var selectModal = state.modals.selectCar.filter;
            selectModal.model.nextValue = nextValue;
            selectModal.model.thisValue = thisValue;
            selectModal.model.status = status;
            selectModal.model.selected = selected;
            selectModal.generation.thisValue = nextValue;
            selectModal.stage = 3;
            selectModal.generation.status = true;
        },
        setFilterGeneration: function (state, action) {
            var _a = action.payload, nextValue = _a.nextValue, thisValue = _a.thisValue, selected = _a.selected, status = _a.status;
            var selectModal = state.modals.selectCar.filter;
            selectModal.generation.nextValue = nextValue;
            selectModal.generation.thisValue = thisValue;
            selectModal.generation.selected = selected;
            selectModal.generation.status = status;
            selectModal.car.status = status;
            selectModal.stage = 4;
        },
        setSelectCar: function (state, action) {
            state.modals.selectCar.filter.car.carSelect = action.payload;
        },
        setStageFilter: function (state, action) {
            state.modals.selectCar.filter.stage = action.payload;
        },
        resetSelectCar: function (state) {
            state.modals.selectCar.filter = selectCarInitialState_1.initialStateModal.modals.selectCar.filter;
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(selectCarsLoader.fulfilled, function (state, action) {
            var selectModal = state.modals.selectCar;
            selectModal.stateLoad.isLoad = false;
            selectModal.stateLoad.error = false;
            selectModal.filter.generation.nextValue = action.payload;
            selectModal.filter.car.carList = action.payload;
        })
            .addCase(selectCarsLoader.pending, function (state) {
            var selectModal = state.modals.selectCar;
            selectModal.stateLoad.isLoad = true;
            selectModal.stateLoad.error = false;
        })
            .addCase(selectCarsLoader.rejected, function (state) {
            var selectModal = state.modals.selectCar;
            selectModal.stateLoad.isLoad = false;
            selectModal.stateLoad.error = true;
        });
    },
});
exports.openModal = (_a = modalSlice.actions, _a.openModal), exports.closeModal = _a.closeModal, exports.setPromotionData = _a.setPromotionData, exports.resetPromotionData = _a.resetPromotionData, exports.setStageFilter = _a.setStageFilter, exports.setFilterModel = _a.setFilterModel, exports.setFilterBrand = _a.setFilterBrand, exports.setFilterGeneration = _a.setFilterGeneration, exports.setSelectCar = _a.setSelectCar, exports.resetSelectCar = _a.resetSelectCar, exports.setOrderType = _a.setOrderType;
exports.default = modalSlice.reducer;
